import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'
import { register as registerSwiperElements } from 'swiper/element/bundle'

registerSwiperElements()

import { ApolloProvider } from '@apollo/client/react'
import { CssBaseline } from '@mui/material'
import { createRoot } from 'react-dom/client'
import AppMain from './AppMain'
import AdminApp from './admin/AdminApp'
import { client } from './apollo'
import CoachApp from './coach/CoachApp'
import { getAppInfo } from './config'
import HomePage from './HomePage'
import LoginRedirector from './LoginRedirector'
import type { SelectedRole } from './LoginRedirector/RoleSelectionDialog'

if (getAppInfo().deployEnv === 'dev') {
  loadDevMessages()
  loadErrorMessages()
}

function App() {
  return (
    <ApolloProvider client={client}>
      <CssBaseline />
      <LoginRedirector
        renderLoginScreen={(onLoginSuccess) => (
          <HomePage onLoginSuccess={onLoginSuccess} />
        )}
        renderApp={(role: SelectedRole) => {
          if (role.type === 'app_admin') return <AdminApp />
          if (role.type === 'coach') return <CoachApp />
          return <AppMain />
        }}
      />
    </ApolloProvider>
  )
}

export default App

const rootEl = document.getElementById('root')

// Vite HMR can re-execute this entry module (e.g. when a dependency like
// AppMain.tsx mixes component and non-component exports and breaks Fast
// Refresh's boundary detection) without a full page reload. Reuse the root
// stashed on the DOM element instead of calling createRoot() again, which
// would stack a second React tree on top of the first.
interface RootHolder {
  _reactRoot?: ReturnType<typeof createRoot>
}

if (rootEl) {
  const holder = rootEl as unknown as RootHolder
  const root = holder._reactRoot ?? createRoot(rootEl)
  holder._reactRoot = root
  root.render(<App />)
}
